export class Lock {
  static readonly type = '[ScrollLock] Lock';
}

export class Unlock {
  static readonly type = '[ScrollLock] Unlock';
}
